import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../root';
const FUNCTION_CODE = 'GET_ALL_ATTACHMENTS';

export async function getAllAttachments(
    userToken: string,
    optionalProps?: Record<string, unknown>
) {
    try {
        const response = await axios.get(
            `${URL}/attachments/${optionalProps?.dealId ? `?deal=${optionalProps.dealId}` : ''}`,
            {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Token ${userToken}`
                }
            },
        );

        return response.data;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur de récuperation de la liste des pièces jointes',
            error: error
        });
    }
}
